import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SiteContentCtx = createContext({
  content: null,
  reload: async () => {},
  saveSection: async () => {},
});

export const SiteContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);

  const reload = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/content`);
      setContent(data);
      return data;
    } catch (e) {
      console.error("Content load failed:", e);
      setContent(false);
      return null;
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  const saveSection = useCallback(
    async (section, value) => {
      const { data } = await axios.put(
        `${API}/content/section/${section}`,
        { value },
        { withCredentials: true },
      );
      setContent(data);
      return data;
    },
    [],
  );

  return (
    <SiteContentCtx.Provider value={{ content, reload, saveSection }}>
      {children}
    </SiteContentCtx.Provider>
  );
};

export const useSiteContent = () => useContext(SiteContentCtx);

/** Merge CMS links with hardcoded fallbacks so every component gets a complete link map. */
const LINK_FALLBACK = {
  discord: "https://discord.gg/7y5VHubfxQ",
  join: "https://cfx.re/join/4gbraqq",
  whitelist:
    "https://discord.com/channels/1159271685451681885/1159271690577121340",
  twitch: "",
  youtube: "",
  instagram: "",
  tiktok: "",
};

export const useLinks = () => {
  const { content } = useSiteContent();
  const lk = (content && content.links) || {};
  return {
    discord: lk.discord || LINK_FALLBACK.discord,
    join: lk.join || LINK_FALLBACK.join,
    whitelist: lk.whitelist || LINK_FALLBACK.whitelist,
    twitch: lk.twitch || LINK_FALLBACK.twitch,
    youtube: lk.youtube || LINK_FALLBACK.youtube,
    instagram: lk.instagram || LINK_FALLBACK.instagram,
    tiktok: lk.tiktok || LINK_FALLBACK.tiktok,
  };
};

/** Resolve image URL: if path-like, prefix with backend; if full URL, leave alone. */
export const resolveImg = (src) => {
  if (!src) return "";
  if (src.startsWith("http://") || src.startsWith("https://")) return src;
  if (src.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${src}`;
  return src;
};
